import { Text, Img, Heading } from "./..";
import React from "react";

export default function VideoProfile({
  type = "Financial",
  videoTitle = "How to Read a P&L",
  viewsText = "30K Views",
  videoTime = "9:16",
  thumbSrc = "/public/images/img_video_screenshot.png",
  videoSrc = "",
  ...props
}) {
  return (
    <div
      className={`${props.className} flex flex-col w-[12%] md:w-full gap-2 pb-2.5 sm:min-w-[157px]`}
    >
      <div
        className={`flex h-[155px] items-center justify-center self-stretch rounded-[12px] bg-cover bg-no-repeat bg-center p-[22px] sm:p-5`}
        style={{ backgroundImage: `url('${thumbSrc}` }}
      >
        <a
          className="flex h-[44px] w-[44px] items-center justify-center rounded-[22px] bg-blue_gray-100_a7 px-2.5"
          href={videoSrc}
        >
          <Img src="images/img_user_gray_100.svg" />
        </a>
      </div>
      <div className="mx-1.5 flex flex-col items-start gap-1 self-stretch">
        <Text
          as="p"
          className="!font-avenir text-[12px] font-medium !text-gray-400"
        >
          {type}
        </Text>
        <div className="flex flex-col items-start gap-1.5 self-stretch">
          <Heading
            size="headings"
            as="p"
            className="!font-avenir text-[14px] line-clamp-2 min-h-[44px] font-black !text-white-a700"
          >
            {videoTitle}
          </Heading>
          <div className="flex items-center justify-between gap-5 self-stretch">
            <div className="flex items-center gap-1">
              <Img
                src="images/img_television.svg"
                alt="30k Views"
                className="h-[8px]"
              />
              <Text
                as="p"
                className="!font-avenir text-[12px] font-medium !text-gray-400"
              >
                {viewsText}
              </Text>
            </div>
            <Text
              size="textxs"
              as="p"
              className="flex items-center justify-center self-end rounded-sm bg-white-a700_3a px-0.5 text-[10px] font-normal capitalize !text-white-a700"
            >
              {videoTime}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
}
